module.exports = __webpack_public_path__ + "static/media/antd.c9241552.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Skills/images/antd.png
// module id = 107
// module chunks = 0